import { useState, useEffect } from 'react';

type Theme = 'light' | 'dark' | 'system';

export function useTheme() {
  const [theme, setTheme] = useState<Theme>(() => {
    // Check localStorage
    const savedTheme = localStorage.getItem('theme');
    if (savedTheme === 'light' || savedTheme === 'dark' || savedTheme === 'system') {
      return savedTheme;
    }
    // Default to system if no saved preference
    return 'system';
  });

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove('light', 'dark');

    if (theme === 'system') {
      const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      
      const applySystemTheme = (e: MediaQueryListEvent | MediaQueryList) => {
        root.classList.remove('light', 'dark');
        if (e.matches) {
          root.classList.add('dark');
        } else {
          // Explicitly add light for clarity, though it's usually default
          root.classList.add('light'); 
        }
      };

      // Apply initial system theme
      applySystemTheme(mediaQuery);

      // Listen for changes
      const handler = (e: MediaQueryListEvent) => applySystemTheme(e);
      mediaQuery.addEventListener('change', handler);
      
      return () => mediaQuery.removeEventListener('change', handler);
    } else {
      root.classList.add(theme);
    }

    localStorage.setItem('theme', theme);
  }, [theme]);

  const setThemeMode = (mode: Theme) => {
    setTheme(mode);
  };

  return { theme, setTheme: setThemeMode };
}
